import type { CharacterPersona } from "./appearance";
import generatedCast from "./illustrated-cast.json";

// Coordinates use the original square artwork, with (0, 0) at the top left.
type Region = readonly [x: number, y: number, radiusX: number, radiusY: number];
export interface IllustratedCharacter {
  slug: string;
  age: number;
  occupation?: string;
  eyes: readonly [Region, Region];
  mouth: Region;
  pivot: readonly [number, number];
  tempo: number;
  partner?: {
    eyes: readonly [Region, Region];
    mouth: Region;
    pivot: readonly [number, number];
  };
}

export const illustratedCast: Record<string, IllustratedCharacter> = {
  ...(generatedCast as unknown as Record<string, IllustratedCharacter>),
  "Maria Garcia": {
    slug: "maria-garcia", age: 52, occupation: "Restaurant manager", tempo: 1,
    eyes: [[0.455, 0.177, 0.032, 0.027], [0.536, 0.193, 0.033, 0.027]],
    mouth: [0.479, 0.254, 0.052, 0.030], pivot: [0.488, 0.355],
  },
  "James Thompson": {
    slug: "james-thompson", age: 55, occupation: "Construction foreman", tempo: 0.88,
    eyes: [[0.443, 0.161, 0.031, 0.025], [0.509, 0.145, 0.031, 0.025]],
    mouth: [0.484, 0.225, 0.052, 0.030], pivot: [0.490, 0.335],
  },
  "Dorothy Miller": {
    slug: "dorothy-miller", age: 81, occupation: "Retired, lives in assisted living", tempo: 0.75,
    eyes: [[0.457, 0.191, 0.030, 0.023], [0.537, 0.165, 0.030, 0.023]],
    mouth: [0.517, 0.256, 0.050, 0.031], pivot: [0.506, 0.368],
  },
};

export function resolveIllustration(persona: CharacterPersona) {
  if (persona.characterId) return Object.values(illustratedCast).find(member => member.slug === persona.characterId);
  const member = illustratedCast[persona.name?.trim() ?? ""];
  return member && (persona.age == null || persona.age === member.age) ? member : undefined;
}

export function illustrationUrl(member: IllustratedCharacter, expression = false) {
  return `/training/characters/illustrated/${member.slug}${expression ? "-expression" : ""}.png`;
}
